import {BaseContainerModel} from '../base-container.model';
import {bl_fi_mst_branch_settlement_method_RowClass} from '../../dbschema';

export class BranchSettlementMethodContainerModel extends BaseContainerModel {
  bl_fi_mst_branch_settlement_method: bl_fi_mst_branch_settlement_method_RowClass = new bl_fi_mst_branch_settlement_method_RowClass();
}
